export const GOOGLE_OAUTH_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}/authenticate/google`;
export const FB_OAUTH_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}/authenticate/facebook`;
export const SUPPORT_PAGE_ENDPOINT = `${process.env.REACT_APP_SUPPORT_PAGE_URL}`;
export const STRIPE_PUBLIC_KEY = `${process.env.REACT_APP_STRIPE_PUBLIC_KEY}`

export const BILLING_COUNTRIES = ["Canada", "United States"];

export const ORDER_STATUS = {
  CONFIRMED: "CONFIRMED",
  CANCELLED: "CANCELLED"
}

export const STATUSES = {
  CONFIRMED: "text-green-700 bg-green-50 border border-green-200",
  CANCELLED: "text-red-700 bg-red-50 border border-red-200",
};

export const SHIPMENT_STATUS_STYLES = {
  created: "bg-blue-50 text-blue-700 border border-blue-200",
  info_received: "bg-blue-50 text-blue-700 border border-blue-200",
  in_transit: "bg-blue-50 text-blue-700 border border-blue-200",
  out_for_delivery: "bg-blue-50 text-blue-700 border border-blue-200",
  available_for_pickup: "bg-blue-50 text-blue-700 border border-blue-200",
  pending: "bg-blue-50 text-blue-700 border border-blue-200",
  failed_attempt: "bg-blue-50 text-blue-700 border border-blue-200",
  exception: "bg-red-50 text-red-700 border border-red-200",
  delivered: "bg-green-50 text-green-700 border border-green-200",
};

export const DEFAULT_SHIPMENT_STATUS_STYLE = "bg-gray-100 text-gray-700";

export function formatShipmentStatus(status) {
  if (!status) return "";

  return status
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
    .toUpperCase()
}

export const carrierDropoffLinks = {
  "federal express": "https://local.fedex.com/en-ca",
  "ups": "https://www.theupsstore.ca/store-finder/",
  "dhl": "https://locator.dhl.com/",
  "canada post": "https://www.canadapost-postescanada.ca/cpc/en/tools/find-a-post-office.page"
};
